// breadcrumbEntities

export const governance = { URI: 'governance', NAME: 'Organization Chart' }
export const govChart = { URI: 'organization-chart', NAME: 'Organization Chart' }
export const managementStructure = { URI: 'management-structure', NAME: 'Management Structure' }
export const managementStructureProfile = { URI: 'management-structure-profile', NAME: 'Management Structure Profile' }
export const complianceSetup = { URI: 'compliance-setup', NAME: 'Compliance Setup' }
export const governanceSetup = { URI: 'governance-setup', NAME: 'Governance Setup' }
export const complianceSetupMandateByLaw = { URI: 'compliance-setup/1', NAME: 'Mandated by Law' }
export const complianceSetupMandateByBoard = { URI: 'compliance-setup/2', NAME: 'Mandated by Board' }
export const manageCompliance = { URI: 'manage-compliance', NAME: 'Manage Compliance' }
export const manageComplianceMandateByLaw = { URI: 'manage-compliance/1', NAME: 'Mandated by Law' }
export const manageComplianceMandateByBoard = { URI: 'manage-compliance/2', NAME: 'Mandated by Board' }
export const settings = { URI: 'settings', NAME: 'Settings' }
export const userManagement = { URI: 'user-management', NAME: 'User Management' }
export const rolesAndPermission = { URI: 'roles-and-permission', NAME: 'Roles and Permission' }
export const userList = { URI: 'user-list', NAME: 'User List' }
export const userProfiles = { URI: 'user-profiles', NAME: 'User Profiles' }
export const risk = { URI: 'risk-register', NAME: 'Risk Register' }
export const riskById = { URI: 'risk-by-id', NAME: 'Risk Register' }
export const raised = { URI: 'raised', NAME: 'Raised' }
export const owned = { URI: 'owned', NAME: 'Owned' }
export const addRisk = { URI: 'add-risk', NAME: 'Add Risk' }
export const history = { URI: 'history', NAME: 'History' }
export const dispute = { URI: 'dispute', NAME: 'Dispute' }
export const RejectedRisk = { URI: 'rejected-risk', NAME: 'Rejected Risk' }
export const Dashboard = { URI: 'dashboard-risk', NAME: 'Dashboard' }
export const compliancePreview = { URI: 'compliance-preview', NAME: 'Compliance Preview' }
export const bodyPreview = { URI: 'body-preview', NAME: 'Governance Preview' }
export const transferCompliance = { URI: 'reassign-compliance', NAME: 'Reassign Compliance' }
export const transferBody = { URI: 'reassign-body', NAME: 'Reassign Regulation' }
export const RESEND_DURATION = 15
export const BODY_TYPE_PARAM = 1
export const FREQUENCY_PARAM = 1
export const STATUS_PARAM = 1

export const dateChanger = (paramDate) => {
    const date = new Date(paramDate)
    const istOffset = 5.5 * 60 * 60 * 1000
    date.setTime(date.getTime() + istOffset)
    date.setDate(date.getDate() + 1)
    return date
}

export const browserDateConvert = (date) => {
    const months = {
        Jan: '01',
        Feb: '02',
        Mar: '03',
        Apr: '04',
        May: '05',
        Jun: '06',
        Jul: '07',
        Aug: '08',
        Sep: '09',
        Oct: '10',
        Nov: '11',
        Dec: '12'
    }

    const dateParts = date.split(' ')

    let year = parseInt(dateParts[3], 10) // "2025"
    const month = months[dateParts[1]] // "03"
    let day = parseInt(dateParts[2], 10) // "01"
    const time = dateParts[4] // "05:30:00"
    const offset = dateParts[6] // "0530" (GMT+05:30)

    // Convert timezone offset to UTC
    const offsetHours = parseInt(offset.slice(0, 2), 10) // 05
    const offsetMinutes = parseInt(offset.slice(2), 10) // 30
    let [ hours, minutes, seconds ] = time.split(':').map(Number)

    // Convert IST to UTC
    hours -= offsetHours
    minutes -= offsetMinutes

    // Handle minutes underflow
    if (minutes < 0) {
        minutes += 60
        hours -= 1
    }

    // Handle hours underflow
    if (hours < 0) {
        hours += 24
        day -= 1 // Reduce one day when going back past midnight
    }

    // Reduce one extra day manually
    day -= 1

    // Handle month underflow when reducing a day
    let newMonth = parseInt(month, 10)
    if (day <= 0) {
        newMonth -= 1 // Move to previous month
        if (newMonth <= 0) {
            newMonth = 12
            year -= 1 // Move to previous year
        }

        // Set day to the last day of the new month
        const daysInMonth = [ 31, (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]
        day = daysInMonth[newMonth - 1]
    }

    // Format back to ISO string
    const formattedMonth = String(newMonth).padStart(2, '0')
    const formattedDay = String(day).padStart(2, '0')
    const formattedHours = String(hours).padStart(2, '0')
    const formattedMinutes = String(minutes).padStart(2, '0')
    const formattedSeconds = String(seconds).padStart(2, '0')

    const isoString = `${year}-${formattedMonth}-${formattedDay}T${formattedHours}:${formattedMinutes}:${formattedSeconds}.000Z`

    return isoString
}

export const INITIATE = 'Initiate & Acknowledge'

export const breadcrumbMap = {
    'risk-register': 'Risk Register',
    dispute: 'Dispute',
    history: 'History',
    'rejected-risk': 'Rejected Risk',
    'manage-org-chart': 'Manage Org Chart',
    'view-org-chart': 'View Org Chart',
    'management-structure': 'Management Structure',
    'management-structure-profile': 'Management Structure Profile',
    'reassign-body': 'Reassign Regulation',
    'reassign-compliance': 'Reassign Compliance',
    'compliance-setup': 'Compliance Setup',
    'governance-setup': 'Governance Setup',
    'manage-compliance': 'Manage Compliance',
    'dashboard-risk': 'Dashboard',
    'dashboard-compliance': 'Dashboard',
    'body-preview': 'Regulation Preview',
    'compliance-preview': 'Compliance Preview',
    'roles-and-permission': 'Roles & Permission',
    settings: 'Settings',
    dashboard: 'Dashboard',
    indicators: 'Indicators',
    'heat-map': 'Heat Map',
    'heat-map-about': 'Heat Map About',
    calendar: 'Calendar',
    'create-meeting': 'New Meeting',
    meeting: 'Meeting',
    'view-meeting': 'View Meeting',
    risk: 'Risk Management',
    'add-risk': 'Add Risk',
    'view-risk-details': 'Risk Details',
    raised: 'Raised Risks',
    owned: 'Owned Risks',
    'chat-and-timeline': 'Chat & Timeline',
    governance: 'Governance',
    'org-chart': 'Org Chart',
    compliance: 'Compliance',
    setup: 'Setup',
    'user-management': 'User Management',
    'user-list': 'User List',
    'roles-permission': 'Roles & Permissions',
    'transfer-body': 'Transfer Body',
    'issue-history': 'Issue History',
    'issue-register': 'Issue Register',
    'add-issue': 'Add Issue',
    issue: 'Issue'
}

export const COMPLIANCE_SETUP = 'compliance-setup'
export const BOARD = 'Board'
export const LAW = 'Law'
export const COMPLIANCE = 'Compliance'
export const NONCOMPLIANCE = 'Non Compliance'
// Dashboard
export const SELF_ID = 1
export const TEAM_ID = 2
export const TRANSFER_STATUS = {
    OWN: 'own'
}

export const ISO_CONVERT = (date) => {
    const dateObj = new Date(date)
    const offset = dateObj.getTimezoneOffset() * 60000 // Convert minutes to milliseconds
    return new Date(dateObj.getTime() - offset).toISOString()
}
export const COMPLIANCE_TAB = {
    ACTIVE: 1,
    INACTIVE: 2,
    UNASSIGNED: 3
}
